import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { sizes } from '../../styles/sizes';
type Variant = 'long' | 'normal';
type Spacing = 'some' | 'compact' | 'none';
const spacings = {
  some: sizes.pixels._3,
  compact: sizes.pixels._1,
  none: 0
};
export const BoxVertical = React.forwardRef((t0, ref) => {
  const $ = _c(11);
  const {
    children,
    sx,
    variant: t1,
    spacing: t2,
    role
  } = t0;
  const variant = t1 === undefined ? "normal" : t1;
  const spacing = t2 === undefined ? "some" : t2;
  let t3;
  if ($[0] !== variant) {
    t3 = variant === "long" ? {
      flex: 1
    } : {};
    $[0] = variant;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const flexSettings = t3;
  const t4 = spacings[spacing];
  let t5;
  if ($[2] !== flexSettings || $[3] !== sx || $[4] !== t4) {
    t5 = {
      gap: t4,
      flexDirection: "column",
      display: "flex",
      ...flexSettings,
      ...sx
    };
    $[2] = flexSettings;
    $[3] = sx;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== ref || $[8] !== role || $[9] !== t5) {
    t6 = <Box ref={ref} sx={t5} role={role}>{children}</Box>;
    $[6] = children;
    $[7] = ref;
    $[8] = role;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
});